<template>
  <div>
    <PageHeader v-if="!isComponent" title="Reports" :links="[
      { name: 'home', label: 'Home' },
      { name: 'reports', label: 'Reports' },
      { name: 'endOfDayClosingReport', label: 'End Of Day Closing' },
    ]">
      <CheckBox :toggleVariable="showLegacyReports" @click="showLegacyReports = !showLegacyReports"
        label="Show Legacy Reports" />
    </PageHeader>
    <div class="home responsive-menu" v-if="!showLegacyReports && !isLoading">
      <div class="responsive-menu__child responsive-menu__sub-section" >
        <div class="section-base" v-canAccess="reportRoles">
          <div class="section-base__header space-between">
            <div class="section-base__header-name">
              <div>
                <i class="fas fa-chart-line"></i>
              </div>
              <div>End Of Day Closing Reports</div>
            </div>
          </div>
          <div>
            <div class="padded elevated-0 bordered spacer-responsive">
              <div v-for="(report, index) in reports" :key="index">
                <inline-button v-if="!report.legacyReportSlug" :to="getReportUrl(report)"
                  type="plain-primary responsive-column" :label="report.name" />
                <inline-button v-else :to="{ name: report.legacyReportSlug }" type="plain-primary responsive-column"
                  :label="report.name" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home responsive-menu" v-if="showLegacyReports && !isLoading">
      <div class="responsive-menu__child responsive-menu__sub-section">
        <div class="section-base" v-canAccess="reportRoles">
          <div class="section-base__header space-between">
            <div class="section-base__header-name">
              <div>
                <i class="fas fa-chart-line"></i>
              </div>
              <div>End Of Day Closing Reports</div>
            </div>
          </div>
          <div class="padded elevated-0 bordered spacer-responsive">
            <inline-button :to="{ name: 'financeDepositSlip' }" type="plain-primary responsive-column"
              label="Deposit Slip" />
            <inline-button :to="{ name: 'inventoryDisposal' }" type="plain-primary responsive-column"
              label="Disposals" />
            <inline-button :to="{ name: 'salesOrderStatusNotPosted' }" type="plain-primary responsive-column"
              label="Open Orders" />
            <inline-button :to="{ name: 'salesSummaryBreakdownReport' }" type="plain-primary responsive-column"
              label="Sales Summary Breakdown" />
            <inline-button :to="{ name: 'inventoryDisposalScheduled' }" type="plain-primary responsive-column"
              label="Scheduled Disposals" />
            <inline-button :to="{ name: 'stateInventory' }" type="plain-primary responsive-column"
              label="State Inventory Check" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reportRoles } from "@/constants/roles";
import PageHeader from "@/components/Header/Header.vue";
import CheckBox from "@/components/CheckBox.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "reports",
  data() {
    return {
      reportRoles,
      showLegacyReports: false,
    };
  },
  components: { PageHeader, CheckBox },
  created: function () {
    this.setPageTitle("Reports");
  },
  mounted: function () {
    this.getReportSettings();
  },
  watch: {
    reportSettings: {
      handler(newVal) {
        this.showLegacyReports = newVal?.showLegacyReports || false;
      },
    },
  },
  computed: {
    ...mapGetters({
      reportSettings: "reports/reportSettings",
      isLoading: "reports/isLoading",
    }),
    reports() {
      const reports = this.reportSettings?.reportConfigs
        ?.filter(report => report.showOnEndOfDayClosingMenu === true) ?? [];

      return reports;
    },
  },
  methods: {
    ...mapActions({
      getReportSettings: "reports/getReportSettings",
    }),
    getReportUrl(report) {
      let name = ""
      if (report.section === "Inventory Reports") {
        name = "inventoryReports"
      } else if (report.section === "Sales Reports") {
        name = "salesReports"
      } else if (report.section === "Financial Reports") {
        name = "financeReports"
      } else if (report.section === "Customer Reports") {
        name = "customerReports"
      } else if (report.section === "Custom Reports") {
        name = "customReports"
      }
      return { name: name, query: { name: report.slug } }
    }
  }
};
</script>

<style lang="scss"></style>